import {Icon} from "semantic-ui-react";

const COLOUR = {
	F: 'pink',
	M: 'blue',
	unknown: 'green',
};

const ICON = {
	F: 'woman',
	M: 'man',
	unknown: 'question',
}

export function SexIcon({value}) {
	const name = ICON[value] || ICON.unknown;
	const color = COLOUR[value] || COLOUR.unknown;

	return <Icon name={name} color={color}/>;
}
